const EN = {name: 'English', value: 'EN'};
const ES = {name: 'Spanish', value: 'ES'};

export default {
  EN,
  ES
}

export const AllLanguages = [EN,ES];
export const AllLanguageKeys = AllLanguages.map(l => l.value);